// extracted by mini-css-extract-plugin
module.exports = {"sit_ting":"MenuRanking_style_sit_ting__ptiom"};